import React from "react";

const HeroValuesDesktop = () => {
  return (
    <>
      <div className="w-full xl:px-0 md:px-6 lg:!px-6 px-5 relative md:bg-bottom bg-center bg-[#F4F4F4] md:py-14 2xl:py-16 md:block hidden">
        <div className="lg:container mx-auto 2xl:px-5 xl:px-2 lg:p-0 text-white z-50 relative">
          <div className="w-full flex justify-center">
            <h2 className="font-bold md:text-[32px] 2xl:text-[36px] text-center inline-block border-b-[4px] border-[#FFBA08] mt-1">
              <span className="text-[#3174d6]">H </span>
              <span className="text-[#BD132D]">E </span>
              <span className="text-[#FFBA08]">R </span>
              <span className="text-[#008D82]">O </span>
              <span className="text-[#071B30]"> Values</span>
            </h2>
          </div>

          <div className="flex flex-col md:flex-row gap-8 p-8 items-center justify-center">
            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-6 w-[264px] h-[352px]">
              <div className="absolute top-[-3px] left-0 w-[64px] h-[64px] rounded-tl-[12px] overflow-hidden flex items-center justify-center">
                <img
                  src="/about-us/h1.png"
                  alt="Hustle & Hard Work"
                  className="w-[110px] h-[98px] object-contain"
                />
              </div>
              <h2 className="text-[24px] font-bold text-gray-900 mt-12 mb-2">
                Hustle & Hard Work
              </h2>
              <p className="text-[#5C5C5C] text-[16px]">
                We embrace relentless dedication to our mission, always going
                the extra mile. This hustle culture is not just about putting in
                the hours; it's also about putting our heart into what we do.
              </p>
            </div>

            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-6 w-[264px] h-[352px]">
              <div className="absolute top-[-3px] left-0 w-[64px] h-[64px] rounded-tl-[12px] overflow-hidden flex items-center justify-center">
                <img
                  src="/about-us/h2.png"
                  alt="Emotional Intelligence"
                  className="w-[110px] h-[98px] object-contain"
                />
              </div>
              <h2 className="text-[24px] font-bold text-gray-900 mt-12 mb-2">
                Emotional Intelligence
              </h2>
              <p className="text-[#5C5C5C] text-[16px]">
                We believe true strength lies in understanding and compassion.
                By prioritizing emotional intelligence, we foster a
                collaborative team culture and enhance relationships with
                clients, partners, and stakeholders.
              </p>
            </div>

            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-6 w-[264px] h-[352px]">
              <div className="absolute top-[-3px] left-0 w-[64px] h-[64px] rounded-tl-[12px] overflow-hidden flex items-center justify-center">
                <img
                  src="/about-us/h3.png"
                  alt="Resilience to Change"
                  className="w-[110px] h-[98px] object-contain"
                />
              </div>
              <h2 className="text-[24px] font-bold text-gray-900 mt-12 mb-2">
                Resilience to Change
              </h2>
              <p className="text-[#5C5C5C] text-[16px]">
                Change is constant, and we thrive by adapting swiftly, evolving
                through innovative business models, and integrating AI and
                technology to transform challenges into opportunities.
              </p>
            </div>

            <div className="relative flex flex-col bg-white rounded-[12px] shadow-md p-6 w-[264px] h-[352px]">
              <div className="absolute top-[-3px] left-0 w-[64px] h-[64px] rounded-tl-[12px] overflow-hidden flex items-center justify-center">
                <img
                  src="/about-us/h4.png"
                  alt="Ownership Mindset"
                  className="w-[110px] h-[98px] object-contain"
                />
              </div>
              <h2 className="text-[24px] font-bold text-gray-900 mt-12 mb-2">
                Ownership Mindset
              </h2>
              <p className="text-[#5C5C5C] text-[16px]">
                We think and act like owners, taking accountability for
                outcomes. Our commitment to making an impact is reflected in our
                drive to lead, excel, and serve.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroValuesDesktop;
